import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import { css } from "aphrodite-jss";
import { styles } from "src/components/dialogs/PublicationSourceDialogStyle";
import { HorizontalBarChart} from "src/components/charts/HorizontalBarChart";
import { ChartItem } from "src/models/ChartItem";
import { appStore } from "src/mobx/AppStore";
import { RequestState } from "src/models/RequestState";

interface IExpenditureProjectDialogProps {
    isOpen: boolean;
    onClose: any;
}

export class ExpenditureProjectDialog extends React.Component<IExpenditureProjectDialogProps> {
    
    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
    };

    public render() {
        let content;
        if(!this.props.isOpen){
            content = (
                <div>
                    
                </div>
            );
        }else{

            const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        
            const projectTitle = "Expenditure by Project";
            const projectToolTip = "2008 -present (as reported on scopus.com)" ;
            
            content = (
                <HorizontalBarChart id="project"
                    state={expenditureData.expenditures_by_project.requestState}
                    data={expenditureData.expenditures_by_project.data}
                    error={expenditureData.expenditures_by_project.error}
                    title={projectTitle}
                    tooltip={projectToolTip}
                    labelName={"Project"}
                    valueLabel={"Amount"}
                    valueFormatter={this.formatValues}
                    tickCutOff={40}
                    yAxisWidth={200}
                />
            )

        }               

        return (
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        {content}
                    </React.Fragment>
                </div>
            </Dialog>
        );
    }

    public formatValues = (value: string) => {
        return "$"+value;
    }
    
}


// WEBPACK FOOTER //
// ./src/components/dialogs/ExpenditureProjectDialog.tsx